import {
    iconClient,
    iconWarranty,
    iconReports,
    iconReportsDefault,
} from '../defaultValues';

const data = {
    role_d0af7e126d654cc1bf74f5acee6ba93b: [
        {
            id: 'neew',
            icon: iconWarranty,
            label: 'Garantía Vehicular',
            to: '/app/warranty',
        },

        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/blank-page',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
            ],
        },
    ],
};
export default data;
